export default __webpack_public_path__ + "static/media/seatting.bb9d7d19.png";